import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {

  @Input() options: any[] = [];

  @Input() labelKey!: string;
  @Input() valueKey?: string;
  @Input() codeKey?: string;

  @Input() showCode = false;

  @Input() placeholder = 'Seleccione';
  @Input() size: 'xs-small' | 's-small' | 'normal' = 'normal';
  @Input() customClass = '';

  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && this.options?.length === 1) {
      const opt = this.options[0];
      const selectedValue = this.valueKey ? opt[this.valueKey] : opt;

      this.value = selectedValue;
      this.valueChange.emit(selectedValue);
    }
  }

  onChange(val: any): void {
    this.value = val;
    this.valueChange.emit(val);
  }
}
